export default __webpack_public_path__ + "static/media/rating.4c6a341a.svg";